import React from 'react'
import { Grid } from '@material-ui/core'

import PageTitle from '../../components/PageTitle'
import AppointmentDurationsSection from './AppointmentDurationsSection'
import AppointmentTypesSection from './AppointmentTypesSection'
import BusinessHoursSection from './BusinessHoursSection'
import ReminderIntervalsSection from './sections/ReminderIntervalsSection'
import HandlerMembershipSection from './sections/HandlerMembershipSection'

const sections = [
    ReminderIntervalsSection,
    BusinessHoursSection,
    AppointmentTypesSection,
    AppointmentDurationsSection,
    HandlerMembershipSection,
]

export default function AppointmentSettings() {
    return (
        <>
            <PageTitle title="Appointment Settings" />
            <Grid container spacing={4}>
                {sections.map((Section, index) => (
                    <Grid item xs={12} key={index}>
                        <Section />
                    </Grid>
                ))}
            </Grid>
        </>
    )
}
